var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppliances(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "11E212C7-CAD8-468D-B7C0-4640050C5B63") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-83",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,32 C3.8954305,32 3,31.1045695 3,30 L3,2 C3,0.8954305 3.8954305,0 5,0 L27,0 C28.1045695,0 29,0.8954305 29,2 L29,30 C29,31.1045695 28.1045695,32 27,32 L5,32 Z M13,27 L5,27 L5,30 L13,30 L13,27 Z M27,27 L15,27 L15,30 L27,30 L27,27 Z M13,2 L5,2 L5,25 L13,25 L13,2 Z M27,2 L15,2 L15,25 L27,25 L27,2 Z M10,7.5 C10.5128358,7.5 10.9355072,7.88604019 10.9932723,8.38337887 L11,8.5 L11,20.5 C11,21.0522847 10.5522847,21.5 10,21.5 C9.48716416,21.5 9.06449284,21.1139598 9.00672773,20.6166211 L9,20.5 L9,8.5 C9,7.94771525 9.44771525,7.5 10,7.5 Z M18,7.5 C18.5128358,7.5 18.9355072,7.88604019 18.9932723,8.38337887 L19,8.5 L19,20.5 C19,21.0522847 18.5522847,21.5 18,21.5 C17.4871642,21.5 17.0644928,21.1139598 17.0067277,20.6166211 L17,20.5 L17,8.5 C17,7.94771525 17.4477153,7.5 18,7.5 Z",
    id: "Combined-Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliances);
export default __webpack_public_path__ + "static/media/appliances.12ce65c8746825ac049339aec506dd02.svg";
export { ForwardRef as ReactComponent };